import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-auth-secondary-action',
  templateUrl: './auth-secondary-action.component.html',
  styleUrls: ['./auth-secondary-action.component.scss']
})
export class AuthSecondaryActionComponent {
  @Input() route: string = '';
  @Input() buttonLabel: string = '';
  @Input() captionLabel: string = '';
  @Input() linkLabel: string = '';
  @Input() dataTest: string = '';
}
